import React, {Component} from "react";

import {NavLink} from "react-router-dom";
import {connect} from "react-redux";
import 'framework7-icons';


	class Footer extends Component {
	state = {
		active_nearme: false,
		active_explore: false,
		active_cart: false,
		active_account: false,
		active_alerts: false,
		unread_alerts_count: null,
	};

	componentDidMount() {
		if (this.props.active_nearme && this.props.active_nearme === true) {
			this.setState({ active_nearme: this.props.active_nearme });
		}

		if (this.props.active_explore && this.props.active_explore === true) {
			this.setState({ active_explore: this.props.active_explore });
		}

		if (this.props.active_cart && this.props.active_cart === true) {
			this.setState({ active_cart: this.props.active_cart });
		}

		if (this.props.active_account && this.props.active_account === true) {
			this.setState({ active_account: this.props.active_account });
		}

		if (this.props.active_alerts && this.props.active_alerts === true) {
			this.setState({ active_alerts: this.props.active_alerts });
		}

		console.log("menu updated props", this.props)
		console.log("menu updated", this.state)

		// if(){
		// 	console.log("chat ongoing", window.tawk.isChatOngoing());
		// }
	}

	render() {
		const { cartTotal, alertUnreadTotal } = this.props;

		return (
			<React.Fragment>
				{/*{localStorage.getItem("showPwaInstallPromptFooter") === "true" && <PWAInstallation type={"footer"} />}*/}

				<div className="d-flex justify-content-center">
					<div
						className={`content pt-10 py-5 font-size-xs clearfix footer-fixed`}
					>
						<NavLink to="/" className="col footer-links px-2 py-1">


							<i className={`f7-icons ${this.state.active_nearme ? "active-footer-tab" : ""}`}>house_alt</i> <br />
							<span className={this.state.active_nearme ? "active-footer-tab" : ""}>
									<span> {localStorage.getItem("footerNearme")}</span>
							</span>
						</NavLink>
						{ <NavLink to="/alerts" className="col footer-links px-2 py-1">
							<span
								className="cart-quantity-badge"
								style={{ backgroundColor: localStorage.getItem("storeColor") }}
							>
								{alertUnreadTotal}
							</span>
							<i className={`f7-icons ${this.state.active_alerts ? "active-footer-tab" : ""}`}>bell</i> <br />
							<span className={this.state.active_alerts ? "active-footer-tab" : ""}>
								{this.state.active_alerts ? (
									localStorage.getItem("footerAlerts")
								) : (
									<span> {localStorage.getItem("footerAlerts")}</span>
								)}
							</span>
						</NavLink> }
						{/*<NavLink to="/chat" className="col footer-links px-2 py-1">
							<span
								className="cart-quantity-badge"
								style={{ backgroundColor: localStorage.getItem("storeColor") }}
							>
								{alertUnreadTotal}
							</span>
							<i className={`f7-icons `}>chat_bubble_2</i> <br />
							<span className={this.state.active_alerts ? "active-footer-tab" : ""}>
								{this.state.active_alerts ? (
									localStorage.getItem("footerAlerts")
								) : (
									<span> {localStorage.getItem("footerAlerts")}</span>
								)}
							</span>
						</NavLink>*/}
						<NavLink to="/explore" className="col footer-links px-2 py-1">
							<i className={`f7-icons ${this.state.active_explore ? "active-footer-tab" : ""}`}>search</i> <br />
							<span className={this.state.active_explore ? "active-footer-tab" : ""}>
								{this.state.active_explore
									? localStorage.getItem("footerExplore")
									: localStorage.getItem("footerExplore")}
							</span>
						</NavLink>
						<NavLink to="/cart" className="col footer-links px-2 py-1">
							<i className={`f7-icons ${this.state.active_cart ? "active-footer-tab" : ""}`}>bag</i> <br />
							<span className={this.state.active_cart ? "active-footer-tab" : ""}>
								{this.state.active_cart
									? localStorage.getItem("footerCart")
									: localStorage.getItem("footerCart")}
								<span
									className="cart-quantity-badge"
									style={{ backgroundColor: localStorage.getItem("storeColor") }}
								>
									{cartTotal.productQuantity}
								</span>
							</span>
						</NavLink>
						<NavLink to="/my-account" className="col footer-links px-2 py-1">
							<i className={`f7-icons ${this.state.active_account ? "active-footer-tab" : ""}`}>person_circle</i> <br />
							<span className={this.state.active_account ? "active-footer-tab" : ""}>
								{this.state.active_account
									? localStorage.getItem("footerAccount")
									: localStorage.getItem("footerAccount")}
							</span>
						</NavLink>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state) => ({
	cartTotal: state.total.data,
	alertUnreadTotal: state.alert.alertUnreadTotal,
});

export default connect(
	mapStateToProps,
	{}
)(Footer);